import React from "react";
import PropTypes from "prop-types";
import cx from "classnames";

const ParticipantSummaryCategoryPrice = ({
    formattedPrice,
    formattedDiscountedPrice,
    formattedPromoPrice,
    hasDiscount,
    hasPromo = false,
    isVisible,
    promoCodeApplied = [],
}) =>
    isVisible ? (
        <>
            <small>
                <span
                    className={cx(hasPromo && "-text-decoration--line-through")}
                >
                    {hasDiscount ? formattedDiscountedPrice : formattedPrice}
                </span>

                {hasPromo && (
                    <strong className="-padding-left--5 -color--system-error">
                        {formattedPromoPrice}
                    </strong>
                )}
            </small>
            <br />
            <small className="-margin-top--0 -text-transform--uppercase -color--system-error">
                <strong>{promoCodeApplied}</strong>
            </small>
        </>
    ) : null;

ParticipantSummaryCategoryPrice.propTypes = {
    // Currency formatted discounted price number as a string
    formattedDiscountedPrice: PropTypes.string.isRequired,
    // Currency formatted price number as a string
    formattedPrice: PropTypes.string.isRequired,
    // Flag telling us to use discounted price
    hasDiscount: PropTypes.bool.isRequired,
    // Currency formatted promo code discounted price number as a string
    formattedPromoPrice: PropTypes.string.isRequired,
    //  Flag telling us to use promo discounted price
    hasPromo: PropTypes.bool,
    // Flag telling us that the price should be visible
    isVisible: PropTypes.bool.isRequired,
    // Name of promo codes to display below new promo price
    promoCodeApplied: PropTypes.arrayOf(PropTypes.string),
};

export default ParticipantSummaryCategoryPrice;
